import { render, staticRenderFns } from "./SidebarCheckboxListField.vue?vue&type=template&id=60af5b46&"
import script from "./SidebarCheckboxListField.vue?vue&type=script&lang=js&"
export * from "./SidebarCheckboxListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports